// extracted by mini-css-extract-plugin
export default {"btn":"ClubRegistrationButton_btn__-2TqE","disabled":"ClubRegistrationButton_disabled__Sluwj","invert":"ClubRegistrationButton_invert__SL-Zl"};